/**
 * Mappers for position create operations
 */

import type {
  CreatePositionRequest,
  CreatePositionResult,
  LC_CreatePositionIn,
  LC_CreatePositionOut,
} from '../types';


export function mapCreatePositionToTransport(
  request: CreatePositionRequest,
): LC_CreatePositionIn {
  return {
    positionCode: request.code,
    positionName: request.name,
    description: request.description,
    areaId: request.areaId,
  };
}

export function mapCreatePositionFromTransport(
  transport: LC_CreatePositionOut,
): CreatePositionResult {
  return {
    id: transport.positionId,
    code: transport.positionCode,
    name: transport.positionName,
    description: transport.description,
    areaId: transport.areaId,
    areaName: transport.areaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
  };
}